var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4D4AB5",
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.953 16.827c-.34-.187-.768-.062-.955.278-.187.34-.063.768.278.955.837.46 1.318.97 1.318 1.4 0 .524-.744 1.338-2.832 2.047-2.063.701-4.82 1.087-7.762 1.087-2.943 0-5.7-.386-7.762-1.087-2.088-.709-2.832-1.523-2.832-2.048 0-.429.48-.94 1.318-1.4.34-.186.465-.614.278-.954-.187-.34-.614-.465-.955-.278C1.113 17.34 0 18.213 0 19.46c0 .955.657 2.317 3.786 3.38C5.99 23.588 8.908 24 12 24c3.092 0 6.01-.413 8.214-1.162 3.13-1.063 3.786-2.425 3.786-3.38 0-1.246-1.113-2.119-2.047-2.632z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.692 20.489c1.428.403 3.313.625 5.309.625s3.88-.222 5.308-.625c1.746-.493 2.632-1.207 2.632-2.122 0-.915-.886-1.63-2.632-2.123-.387-.109-.809-.205-1.257-.287-.244.42-.499.854-.765 1.299.496.074.961.166 1.385.273 1.285.328 1.754.696 1.85.838-.096.142-.565.51-1.85.837-1.217.31-2.782.487-4.43.503-.08.005-.16.009-.241.009-.081 0-.162-.004-.242-.01-1.648-.015-3.213-.192-4.43-.502-1.284-.327-1.754-.696-1.85-.837.096-.142.566-.51 1.85-.838.424-.107.89-.199 1.386-.273-.267-.445-.522-.878-.765-1.299-.449.082-.87.178-1.258.287-1.746.494-2.631 1.208-2.631 2.123 0 .915.885 1.629 2.631 2.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 18.311c.626 0 1.195-.319 1.521-.853 2.288-3.743 5.015-8.677 5.015-10.922C18.537 2.932 15.605 0 12.001 0 8.397 0 5.465 2.932 5.465 6.536c0 2.245 2.727 7.178 5.015 10.922.327.534.895.853 1.521.853zM9.374 6.087C9.374 4.64 10.552 3.46 12 3.46c1.449 0 2.627 1.179 2.627 2.627 0 1.45-1.178 2.628-2.627 2.628-1.448 0-2.627-1.179-2.627-2.628z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocate);
export default __webpack_public_path__ + "static/media/locate.8566a391.svg";
export { ForwardRef as ReactComponent };